import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';
import { make } from 'vuex-pathify';

Vue.use(Vuex);

const state = {
    serviceUrl: (process.env.NODE_ENV === 'development') ? 'http://192.168.0.122:8081' : 'https://api.tapshomeremodeling.com',
    imageUrl: (process.env.NODE_ENV === 'development') ? 'http://192.168.0.122:8000/' : 'https://www.tapshomeremodeling.com/',
    serviceEndpoints: {
        SEND_EMAIL: '/api/v1/public/sendEmail/',
        GET_GALLERY_SMALL: '/api/v1/public/smallGallery/',
        GET_GALLERY_MAIN: '/api/v1/public/gallery/',
        GET_SERVICE_ROW1: '/api/v1/public/serviceRow/1',
        GET_SERVICE_ROW2: '/api/v1/public/serviceRow/2',
        GET_DESCRIPTORS: '/api/v1/public/descriptors',
        GET_CAROUSEL: '/api/v1/public/carousel',
        GET_SITE_ATTRIBUTES: '/api/v1/public/siteAttributes'
    },
    navbarLargeLogo: undefined,
    navbarLogo: undefined,
    phoneLink: '',
    phoneValue: '',
    street: '',
    city: '',
    state: '',
    zip: '',
    contactEmail: '',
    siteName: '',
    siteSubname: '',
    firstRedBlock: '',
    secondRedBlock: '',
    descriptorImage: '',
    carousel: [
    ],
    descriptors: [
    ],
    servicesColumn1: [
    ],
    servicesColumn2: [
    ],
    smallGalleryImages: [
    ],
    largeGalleryImages: [
    ]
};

const mutations = make.mutations(state);

export default  new Vuex.Store({
    plugins: [pathify.plugin],
    state,
    mutations,
})